import React from 'react';
import { connect } from 'react-redux';
import { notification } from 'antd';
import { injectIntl } from 'react-intl';

import {
  getNotificationMessage,
  getNotificationDescription,
  getNotificationType,
} from 'store/notification/selector';

import { NOTIFICATION_TYPE } from 'common/enum';

class ToastNotification extends React.Component {
  notifyMessage(prevProps) {
    const {
      intl,
      notificationMessage,
      notificationDescription,
      notificationType,
    } = this.props;
    if (
      prevProps.notificationMessage !== notificationMessage &&
      notificationMessage
    ) {
      let messageStr = '';
      let descriptionStr = '';

      if (notificationDescription && notificationDescription.id) {
        descriptionStr = intl.formatMessage(
          {
            id: notificationDescription.id,
          },
          notificationDescription.value,
        );
      }

      if (notificationMessage && notificationMessage.id) {
        messageStr = intl.formatMessage(
          {
            id: notificationMessage.id,
          },
          notificationMessage.value,
        );
        const content = {
          message: messageStr,
          description: descriptionStr,
        };
        switch (notificationType) {
          case NOTIFICATION_TYPE.SUCCESS:
            notification.success(content);
            break;
          case NOTIFICATION_TYPE.ERROR:
            notification.error(content);
            break;
          case NOTIFICATION_TYPE.WARNING:
            notification.warn(content);
            break;
          case NOTIFICATION_TYPE.INFO:
            notification.info(content);
            break;
          default:
            notification.success(content);
            break;
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    this.notifyMessage(prevProps);
  }

  render() {
    return <div />;
  }
}
const mapStateToProps = state => ({
  notificationMessage: getNotificationMessage(state),
  notificationDescription: getNotificationDescription(state),
  notificationType: getNotificationType(state),
});
export default injectIntl(
  connect(
    mapStateToProps,
    null,
  )(ToastNotification),
);
